/*
 * As the user scrolls up/down the page make the sidebar float within the
 * limits set by its container
 *
 * '''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''
 * '                                                                   '
 * '                                          '''''''''''''''''''''''' '
 * '                                          '                      ' ' 
 * '                                          ' '''''''''''''''''''' ' ' 
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '         MAIN                             ' '   SIDEBAR        ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '                  ' ' '
 * '                                          ' '''''''''''''''''''' ' '
 * '                                          '                      ' '
 * '                                          '     SIDEBAR          ' '
 * '                                          '     CONTAINER        ' '
 * '                                          '                      ' '
 * '                                          '                      ' '
 * '                                          '''''''''''''''''''''''' '
 * '                                                                   '
 * ' ''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''' '
 * ' '                                                               ' '
 * ' '                     FOOTER                                    ' '
 * ' '                                                               ' '
 * ' ''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''' '
 * '                                                                   '
 * '''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''
 *
 *
 * HTML structure:
 *
 * <div class="mySidebarContainerClass js_mySidebarContainerClass">
 *      <div class="mySidebarClass js_mySidebarClass">
 *          Sidebar content
 *      </div>
 * </div>
 *
 *
 * LESS structure:
 *
 * .mySidebarContainerClass {
 *      position:relative;
 * }
 *
 * .mySidebarClass {
 *
 *      &--floating {
 *          position:fixed;
 *          top:20px;
 *          width:443px;
 *          max-height:90vh;
 *          overflow:auto;
 *
 *          &.mySidebarClass--fixToBottom {
 *              position: absolute;
 *              top: unset;
 *              bottom: 0;
 *          }
 *      }
 * }
 *
 *
 * Usage:
 *
 *
 *  import floatingSidebar from 'path/to/global/floating-sidebar';
 *
 *  floatingSidebar('js_mySidebarContainerClass', 'js_mySidebarClass', 'mySidebarClass--floating', 'mySidebarClass--fixToBottom');
 *
 *
 */

function showFloatingSidebar(floatingSidebar, sidebarContainer, sidebarFloatingClass, sidebarFixedClass) {
    const floatingSidebarYpos = floatingSidebar.getBoundingClientRect().top + window.scrollY;
    const floatingSidebarBottomEdge = floatingSidebarYpos + floatingSidebar.getBoundingClientRect().height;
    const sidebarContainerTopEdge = sidebarContainer.getBoundingClientRect().top + window.scrollY;
    const sidebarContainerBottomEdge = sidebarContainer.getBoundingClientRect().top + window.scrollY + sidebarContainer.getBoundingClientRect().height;

    if (window.scrollY > sidebarContainerTopEdge) {
        floatingSidebar.classList.add(sidebarFloatingClass);
    } else {
        floatingSidebar.classList.remove(sidebarFloatingClass);
    }

    if (floatingSidebarBottomEdge >= sidebarContainerBottomEdge) {
        floatingSidebar.classList.add(sidebarFixedClass);
    } 

    if ((window.scrollY + floatingSidebar.clientHeight + 20) < sidebarContainerBottomEdge) {
        floatingSidebar.classList.remove(sidebarFixedClass);
    }
}

function init(sidebarContainerClass, sidebarClass, sidebarFloatingClass, sidebarFixedClass) {
    const floatingSidebar = document.querySelector(`.${sidebarClass}`);
    const sidebarContainer = document.querySelector(`.${sidebarContainerClass}`);

    if (floatingSidebar && sidebarContainer) {
        showFloatingSidebar(floatingSidebar, sidebarContainer, sidebarFloatingClass, sidebarFixedClass);

        document.addEventListener('scroll', e => showFloatingSidebar(floatingSidebar, sidebarContainer, sidebarFloatingClass, sidebarFixedClass));
    }
}

function floatingSidebar(sidebarContainerClass, sidebarClass, sidebarFloatingClass, sidebarFixedClass) {
    $(document).ready(() => init(sidebarContainerClass, sidebarClass, sidebarFloatingClass, sidebarFixedClass));
}

export default floatingSidebar;
